<template>
  <div class="logo-wrapper">
    <img class="logo-img" src="/assets/images/logo.png" alt="logo" :style="{maxHeight : maxHeight + 'px'}" draggable="false">
  </div>
<!--  <div class="p-d-flex p-jc-between p-ai-center">-->
<!--    <img class="logo-img" src="assets/layout/images/logo_small.png" :style="{maxHeight : maxHeight + 'px'}"/>-->
<!--    <div class="logo-text">Virtual<span class="blue-font-color">Garage</span></div>-->
<!--  </div>-->
</template>

<script>
export default {
  name: "Logo",
  props: {
    maxHeight: {
      type: [String, Number],
      default: 60
    }
  }
}
</script>

<style lang="scss" scoped>
.logo-img {
  display: block;
  max-width: 260px;
  //width: 260px;
}
.logo-text {
  font-size: 32px;
  font-weight: 600;
  color: #fff;
  text-shadow: 1px 1px 4px #313131;
}
.blue-font-color {
  color: #00b8fc;
}
</style>